import { criarDestino } from '@/uteis/action/protocolo-externo/destinatario'
import { gerenciarAtributos } from '@/uteis/action/protocolo-externo/atributos'

const getMotivo = (processo) => {
  if (processo.ultimaTramitacao.atributos) {
    return processo.ultimaTramitacao.atributos.motivo || ''
  }

  return ''
}

export const criarTramitacaoProtocoloExterno = (processo, dadosSessao, dadosEstrutura, lote) => {
  return {
    processos: [{
      numero: processo.processo,
      motivo: getMotivo(processo)
    }],
    lote: lote,
    executor: processo.ultimaTramitacao.destino,
    origem: processo.ultimaTramitacao.destino,
    destino: criarDestino(dadosSessao),
    atributos: gerenciarAtributos(processo, dadosSessao, dadosEstrutura)
  }
}
